// extracted by mini-css-extract-plugin
module.exports = {"container":"menus-main-container","bottom":"menus-main-bottom"};